<template>
  <div>
    <input
      ref="fileInput"
      type="file"
      accept=".pdf,.jpg,.jpeg,.png,.mp4,.doc,.docx,.xlsx,.xls"
      @change="handleFilesSelected"
      multiple
      class="d-none"
    />

    <!-- Simple mode: button only -->
    <b-button v-if="simple" variant="outline-primary" size="sm" @click.stop="triggerFileInput">
      <font-awesome-icon :icon="['fal', 'plus']" class="mr-1" />
      {{ $t('Webportal.Actions.InquiryWizard.Attachment.SelectFiles') }}
    </b-button>

    <!-- Full drop zone mode -->
    <div 
      v-else
      class="upload-drop-zone"
      :class="{ 'is-dragging': isDragging }"
      @dragenter.prevent="handleDragEnter"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop"
    >
      <font-awesome-icon :icon="['fal', 'plus-circle']" size="3x" class="text-muted mb-2" />
      <div class="font-weight-bold mb-1">{{ $t('Webportal.Actions.InquiryWizard.Attachment.DropHere') }}</div>
      <div class="small text-muted">{{ $t('Webportal.Actions.InquiryWizard.Attachment.ClickToSelect') }}</div>
      <b-button variant="primary" class="my-2" @click.stop="triggerFileInput">{{ $t('Webportal.Actions.InquiryWizard.Attachment.SelectFiles') }}</b-button>
      <div class="small text-muted">{{ $t('Webportal.Actions.InquiryWizard.Attachment.SupportedFormats') }}</div>
    </div>

    <!-- Metadata Dialog for new uploads -->
    <AttachmentMetadataDialog
      :show="showMetadataDialog"
      :attachments="pendingFiles"
      @attachments-added="handleAttachmentsAdded"
      @hidden="handleDialogHidden"
    />
  </div>
</template>

<script>
import AttachmentMetadataDialog from "./AttachmentMetadataDialog.vue";

export default {
  name: "AttachmentDropZone",

  components: {
    AttachmentMetadataDialog,
  },

  props: {
    simple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDragging: false,
      pendingFiles: [],
      showMetadataDialog: false,
    };
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleDragEnter() {
      this.isDragging = true;
    },

    handleDragOver() {
      this.isDragging = true;
    },

    handleDragLeave(e) {
      if (e.target.classList.contains("upload-drop-zone")) {
        this.isDragging = false;
      }
    },

    handleDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        this.pendingFiles = Array.from(files);
        this.showMetadataDialog = true;
      }
    },

    handleFilesSelected(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      this.pendingFiles = Array.from(files);
      this.showMetadataDialog = true;
      // Reset input so the same file can be selected again
      this.$refs.fileInput.value = "";
    },

    handleAttachmentsAdded(attachments) {
      this.$emit("attachments-added", attachments);
    },

    handleDialogHidden() {
      this.showMetadataDialog = false;
      this.pendingFiles = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-drop-zone {
  border: 2px dashed #dee2e6;
  border-radius: 0.25rem;
  padding: 2rem;
  text-align: center;
  transition: all 0.2s ease;

  &.is-dragging {
    border-color: var(--primary);
    background-color: #f8f9fa;
  }
}
</style>
